import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'

new Vue ({
    el: '#app' ,
    render: createElement => createElement(App)
})
